import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import ChargePointAddView from '../../components/ChargePointAddView';
import { useSelector } from 'react-redux';

ChargePointAddScreen.propTypes = {};

function ChargePointAddScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeStationId = router.query?.chargeStationId;
  const chargePointId = router.query?.chargePointId;
  const { user } = useSelector((state) => state.auth);

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {chargeStationId
          ? UIHelper.buildBreadcrumb([
            {
              title: 'Danh sách trạm sạc',
              onPress: () => {
                router.navigate(AppRoute.stationList);
              },
            },
            {
              title: 'Chi tiết trạm sạc',
              onPress: () => {
                router.navigate(-1);
              },
            },
            { title: chargePointId ? 'Sửa trụ sạc' : 'Thêm trụ sạc' },
          ])
          : UIHelper.buildBreadcrumb([
            {
              title: 'Danh sách trụ sạc',
              onPress: () => {
                router.navigate(AppRoute.pointList);
              },
            },
            { title: chargePointId ? 'Sửa trụ sạc' : 'Thêm trụ sạc' },
          ])}
      </div>
      <div>
        <ChargePointAddView chargeStationId={chargeStationId} chargePointId={chargePointId} />
      </div>
    </div>
  );
}

export default ChargePointAddScreen;
